import { Box } from "@chakra-ui/react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import MotionPathPlugin from "gsap/dist/MotionPathPlugin";
import { registerGsapPlugins } from "lib/gsap";
import React, { useRef } from "react";
import { HeroSvg } from "./hero-svg";

registerGsapPlugins(ScrollTrigger, MotionPathPlugin);

export function HeroAnimation() {
  const ref = useRef<HTMLDivElement>(null);
  const timeline = useRef<gsap.core.Timeline>();

  useGSAP(
    () => {
      MotionPathPlugin.convertToPath("circle");
      MotionPathPlugin.convertToPath("ellipse");
      const animationConfig = {
        defaults: {
          duration: 3,
          ease: "linear",
          repeat: -1,
          repeatDelay: 0.6,
        },
        scrollTrigger: {
          trigger: "#real-time-hero-animation",
          start: "top center",
          end: "+=1500",
          toggleActions: "play pause resume pause",
        },
      };
      timeline.current = gsap
        .timeline(animationConfig)
        .to("#real-time-dot-1", {
          duration: 1.3,
          repeatDelay: 0.75,
          motionPath: {
            path: "#real-time-line-1",
            align: "#real-time-line-1",
            alignOrigin: [0.5, 0.5],
            offsetX: 8,
            type: "cubic",
          },
        })
        .to(
          "#real-time-dot-2",
          {
            motionPath: {
              path: "#real-time-line-2",
              align: "#real-time-line-2",
              alignOrigin: [0.5, 0.5],
              autoRotate: true,
              type: "cubic",
            },
          },
          "<+=0.4",
        )
        .to(
          "#real-time-dot-3",
          {
            motionPath: {
              path: "#real-time-line-3",
              align: "#real-time-line-3",
              alignOrigin: [0.5, 0.5],
              autoRotate: true,
              type: "cubic",
              start: 0,
            },
          },
          "<+=0.45",
        )
        .to(
          "#real-time-dot-4",
          {
            motionPath: {
              path: "#real-time-line-4",
              align: "#real-time-line-4",
              alignOrigin: [0.5, 0.5],
              autoRotate: true,
              type: "cubic",
              start: 0,
            },
          },
          "<+=0.6",
        )
        .to(
          "#real-time-dot-5",
          {
            motionPath: {
              path: "#real-time-line-5",
              align: "#real-time-line-5",
              alignOrigin: [0.5, 0.5],
              autoRotate: true,
              type: "cubic",
              start: 0,
            },
          },
          "<+=0.5",
        );
    },
    { scope: ref },
  );

  return (
    <Box ref={ref} id="real-time-hero-animation" pos="relative" boxSize="100%">
      <HeroSvg />
    </Box>
  );
}
